module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-rustic-3-dc800c1b5b26ac38f831bc06cca19e99.webp";